import { render, staticRenderFns } from "./reactivate-modal.vue?vue&type=template&id=d06708ae&"
import script from "./reactivate-modal.vue?vue&type=script&lang=js&"
export * from "./reactivate-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports